function Storage(json) {
    this._langs = {};

    if (json) {
        this.merge(json);
    }
}

Storage.prototype.merge = function(json) {
    let self = this;

    if (!json.keysets) { return }
    Object.keys(json.keysets).forEach(function(keysetName) {
        let keyset = json.keysets[keysetName];

        if (!keyset.keys) { return }
        Object.keys(keyset.keys).forEach(function(keyName) {
            let key = keyset.keys[keyName];
            let info = key.info;

            if (!info) { return }

            if (!key.translations) { return }
            Object.keys(key.translations).forEach(function(lang) {
                let trans = key.translations[lang];

                self._langs[lang] = self._langs[lang] || {};
                self._langs[lang][keysetName] = self._langs[lang][keysetName] || {};
                self._langs[lang][keysetName][keyName] = {
                    isPlural: info.is_plural || false,
                    form: trans.form,
                    one: trans.form1,
                    some: trans.form2,
                    many: trans.form3,
                    none: trans.form4,
                };
            });
        });
    });
};

Storage.prototype.languages = function() {
    return Object.keys(this._langs);
};

Storage.prototype.keysets = function(language) {
    if (!this._langs[language]) { return [] }

    return Object.keys(this._langs[language]);
};

Storage.prototype.keys = function(language, keyset) {
    if (!this._langs[language]) { return [] }

    if (!this._langs[language][keyset]) { return [] }

    return Object.keys(this._langs[language][keyset]);
};

Storage.prototype.key = function(language, keyset, key) {
    if (!this._langs[language]) { return undefined }

    if (!this._langs[language][keyset]) { return undefined }

    return this._langs[language][keyset][key];
};

module.exports = Storage;
